module.exports = __webpack_public_path__ + "img/gift.be2616a4.svg";